import {AfterViewInit, Directive, ElementRef, HostListener, Input, Renderer2} from '@angular/core';

@Directive({
             selector: '[appAutoHeightElement]'
           })
export class AutoHeightDirective implements AfterViewInit {

  @Input()
  marginOffSet = 0;

  constructor(private element: ElementRef,
              private renderer: Renderer2) {
  }

  ngAfterViewInit(): void {
    this.setDIVHeight();
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.setDIVHeight();
  }

  setDIVHeight(): void {
    const divHeight = (window.innerHeight - this.element.nativeElement.offsetTop) - this.marginOffSet;
    this.renderer.setStyle(this.element.nativeElement, 'height', `${divHeight}px`);
  }
}
